import type { ApplicationConfig } from '@angular/core';
import { appRoutes } from './app.routes';
import {
  ALLOW_BRANDING_QUERY_PARAM,
  SPARTE_API_BASE_PATH,
  infrastructureProviders,
} from '@comparit/infrastructure';
import {
  ENABLE_TEST_DATA_VIEWER,
  ResultsBaseService,
  TarifdetailsBaseService,
  VergleichBaseService,
} from '@comparit/calculator';
import { provideAppRouter, uiProvidersConfig } from '@comparit/core';
import { environment } from '../environments/environment';
import { BASE_PATH } from '../interfaces/generated';
import { BASE_PATH as COMMON_API_BASE_PATH } from '@comparit/common-api';
import { ResultsService } from '../services/results.service';
import { TarifdetailsService } from '../services/tarifdetails.service';
import { VergleichService } from '../services/vergleich.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppRouter(appRoutes),
    // The libraries decide the API root (infrastructureProviders, from the brand or environment);
    // the generated clients follow it. A lib may never name an app's generated BASE_PATH itself.
    // Two of them, because there are two generated clients — this app's own and the shared one.
    // They are distinct InjectionTokens: providing one does not provide the other, and a missing
    // second provider compiles cleanly and fails only when a shared service is first called.
    { provide: BASE_PATH, useExisting: SPARTE_API_BASE_PATH },
    { provide: COMMON_API_BASE_PATH, useExisting: SPARTE_API_BASE_PATH },
    // The shared results page injects the abstract engine; this app's subclass is its one instance.
    { provide: ResultsBaseService, useExisting: ResultsService },
    // Same for the shared comparison page.
    { provide: VergleichBaseService, useExisting: VergleichService },
    // Same for the shared Tarifdetails page and its Laden bridge.
    { provide: TarifdetailsBaseService, useExisting: TarifdetailsService },
    { provide: ENABLE_TEST_DATA_VIEWER, useValue: environment.enableTestDataViewer },
    {
      provide: ALLOW_BRANDING_QUERY_PARAM,
      useValue: environment.allowBrandingQueryParam,
    },
    ...infrastructureProviders({ apiUrl: environment.apiUrl }),
    ...uiProvidersConfig,
  ],
};
